import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTimePicker } from "@mui/x-date-pickers";
import Base from "components/Base";
import { useToastContext } from "components/alert/ToastContext";
import ReportEdit from "components/reports/ReportEdit";
import { useFilter } from "contexts/FilterContext";
import dayjs from "dayjs";
import duration from 'dayjs/plugin/duration';
import saveAs from 'file-saver';
import { BaseModel } from "model/BaseModel";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Usuario from "model/administracao/cadastro/Usuario";
import Atividade from "model/gestao/atividades/Atividade";
import AtividadeApontamento from "model/gestao/atividades/AtividadeApontamento";
import AtividadeApontamentoAgrupamentoFiltro from "model/gestao/atividades/AtividadeApontamentoAgrupamentoFiltro";
import AtividadeGrupoHorario from "model/gestao/atividades/AtividadeGrupoHorario";
import AtividadeUsuarioHorario from "model/gestao/atividades/AtividadeUsuarioHorario";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable, DataTableRowToggleEvent } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import { SplitButton } from "primereact/splitbutton";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router';
import AtividadeApontamentoService from "service/gestao/atividades/AtividadeApontamentoService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";

dayjs.extend(duration);

const atividadeApontamentoService = new AtividadeApontamentoService();
const usuarioLogadoService = new UsuarioLogadoService();
const hoje = new Date();
const primeiroDiaDoMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
const ultimoDiaDoMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0, 23, 59);
export default function AtividadeApontamentoFiltroListagem() {

    const navigate = useNavigate();

    const { filters, updateFilters } = useFilter();
    const screen = 'AtividadeApontamentoListagem';


    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    const [rows, setRows] = useState<AtividadeApontamento[]>([]);
    const [listaHorarioUsuario, setListaHorarioUsuario] = useState<AtividadeUsuarioHorario[]>([]);
    const [listaGrupoUsuario, setListaGrupoUsuario] = useState<AtividadeGrupoHorario[]>([]);
    const [expandedRows, setExpandedRows] = useState<AtividadeApontamento[] | any>([]);
    const [excluindo, setExcluindo] = useState<boolean>(false);
    const [filtrando, setFiltrando] = useState<boolean>(false);

    const [accordionActiveIndex, setAccordionActiveIndex] = useState<number | number[]>(0);

    const [tipoAgrupamento, setTipoAgrupamento] = useState<string>('U');
    const [dataInicio, setDataInicio] = useState<Date | null>(primeiroDiaDoMes);
    const [dataFim, setDataFim] = useState<Date | null>(ultimoDiaDoMes);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [clientes, setClientes] = useState<Pessoa[]>([]);
    const [atividades, setAtividades] = useState<Atividade[]>([]);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState<Usuario>(new Usuario(0, null, 'Todos'));
    const [clienteSelecionado, setClienteSelecionado] = useState<Pessoa>(new Pessoa(0, null, 0, 'Todos'));
    const [atividadeSelecionada, setAtividadeSelecionada] = useState<Atividade>(new Atividade(0, null, 'Todas'));
    const [mostraUsuariosInativos, setMostraUsuariosInativos] = useState<boolean>(false);
    const [verDescricao, setVerDescricao] = useState<boolean>(false);
    const [cobranca, setCobranca] = useState<string>('T');
    const [faturado, setFaturado] = useState<string>('T');
    const [visibleEditarRelatorio, setVisibleEditarRelatorio] = useState<boolean>(false);
    const [editaRelatoriosSintetico, setEditaRelatoriosSintetico] = useState<boolean>(false);
    const [editaRelatoriosAnalitico, setEditaRelatoriosAnalitico] = useState<boolean>(false);

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioTemAcao(resposta, "RELATORIO_APONTAMENTOS")) {
                setEditaRelatoriosSintetico(true);
            }
            if (usuarioTemAcao(resposta, "RELATORIO_APONTAMENTOS_ANALITICO")) {
                setEditaRelatoriosAnalitico(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });

        buscarListagens().then(() => {
            if (filters[screen]) {
                setFiltro(filters[screen]);
                load(filters[screen]);
            } else {
                load();
            }
        });

    }, []);

    useEffect(() => {
        console.log(dataInicio)
    }, [dataInicio])

    async function buscarListagens() {
        const tecnicosPromise = atividadeApontamentoService.tecnicos().then(resposta => {
            setUsuarios([new Usuario(0, null, 'Todos'), ...resposta]);
            if (filters[screen] && filters[screen].idTecnico) {
                for (let index = 0; index < resposta.length; index++) {
                    if (resposta[index].id === filters[screen].idTecnico) {
                        setUsuarioSelecionado(resposta[index]);
                        break;
                    }
                }
            }
        });

        const clientePromise = atividadeApontamentoService.clientes().then(resposta => {
            setClientes([new Pessoa(0, null, 0, 'Todos'), ...resposta]);
            if (filters[screen] && filters[screen].idCliente) {
                for (let index = 0; index < resposta.length; index++) {
                    if (resposta[index].id === filters[screen].idCliente) {
                        setClienteSelecionado(resposta[index]);
                        break;
                    }
                }
            }
        });

        const atividadePromise = atividadeApontamentoService.atividades().then(resposta => {
            setAtividades([new Atividade(0, null, 'Todas'), ...resposta]);
            if (filters[screen] && filters[screen].idAtividade) {
                for (let index = 0; index < resposta.length; index++) {
                    if (resposta[index].id === filters[screen].idAtividade) {
                        setAtividadeSelecionada(resposta[index]);
                        break;
                    }
                }
            }
        });

        await Promise.all([atividadePromise, tecnicosPromise, clientePromise]);
    }

    function usuarioTemAcao(acoes: any, acao: any): boolean {
        return acoes.some((a: any) => a.sigla === acao);
    }

    function load(filters?: any) {
        setRows([]);
        setListaHorarioUsuario([]);
        setListaGrupoUsuario([]);
        setExpandedRows([]);
        setFiltrando(true);
        setTimeout(() => {
            let filtros = filters ? filters : getFiltro();
            updateFilters(screen, filtros);
            atividadeApontamentoService
                .pesquisarAgrupado(filtros)
                .then(retorno => {
                    setFiltrando(false);
                    setRows(retorno.itens);
                    setListaHorarioUsuario(retorno.usuarios);
                    setListaGrupoUsuario(retorno.grupos);
                })
                .catch(err => {
                    setFiltrando(false);
                });
        }, 300);
    }

    function getFiltro() {

        const filtro = new AtividadeApontamentoAgrupamentoFiltro();
        filtro.tipoAgrupamento = tipoAgrupamento;
        filtro.dataInicio = dataInicio;
        filtro.dataFim = dataFim;
        filtro.mostraUsuariosInativos = mostraUsuariosInativos;
        filtro.verDescricao = verDescricao;

        if (usuarioSelecionado.id) {
            filtro.idTecnico = usuarioSelecionado.id;
        } else {
            filtro.idTecnico = null;
        }

        if (clienteSelecionado.id > 0) {
            filtro.idCliente = clienteSelecionado.id;
        } else {
            filtro.idCliente = null;
        }

        if (atividadeSelecionada.id > 0) {
            filtro.idAtividade = atividadeSelecionada.id;
        } else {
            filtro.idAtividade = null;
        }

        if (cobranca === 'S') {
            filtro.cobranca = true;
        } else if (cobranca === 'N') {
            filtro.cobranca = false;
        } else {
            filtro.cobranca = null;
        }

        if (faturado === 'S') {
            filtro.faturado = true;
        } else if (faturado === 'N') {
            filtro.faturado = false;
        } else {
            filtro.faturado = null;
        }

        return filtro;
    }

    function setFiltro(filtro: any) {
        setTipoAgrupamento(filtro.tipoAgrupamento);
        setDataInicio(filtro.dataInicio);
        setDataFim(filtro.dataFim);
        setVerDescricao(filtro.verDescricao);
        setMostraUsuariosInativos(filtro.mostraUsuariosInativos);
        if (filtro.cobranca === true) {
            setCobranca('S');
        } else if (filtro.cobranca === false) {
            setCobranca('N');
        }
        if (filtro.faturado === true) {
            setFaturado('S');
        } else if (filtro.faturado === false) {
            setFaturado('N');
        }
    }

    function converteData(data: Date | null): string {

        if (data == null) {
            return "";
        }
        data = new Date(data);
        return data.getDate().toString().padStart(2, "0") + "/" + (data.getMonth() + 1).toString().padStart(2, "0") + "/" + data.getFullYear().toString() + " " + data.getHours().toString().padStart(2, "0") + ":" + data.getMinutes().toString().padStart(2, "0");
    }

    function novo() {
        let url = `/apontamento/cadastrar`;
        navigate(`${url}`);
    }

    function getHeader() {

        return (
            <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>

                <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Apontamentos</span>
                <div>
                    <Button
                        style={{}}
                        type="button" icon={<FontAwesomeIcon icon="add" />}
                        className="ui-button-info"
                        onClick={() => novo()}
                    ></Button>
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    {(editaRelatoriosSintetico || editaRelatoriosAnalitico) ?
                        <SplitButton
                            onClick={() => getRelatorioApontamentos()}
                            label="Relatório" style={{ width: 180 }}
                            model={[
                                { label: 'Analítico', command: () => { getRelatorioApontamentosAnalitico() } },
                                { label: 'Editar relatório', command: () => { setVisibleEditarRelatorio(true) } }
                            ]}

                        />
                        :
                        <SplitButton
                            onClick={() => getRelatorioApontamentos()}
                            label="Relatório" style={{ width: 180 }}
                            model={[
                                { label: 'Analítico', command: () => { getRelatorioApontamentosAnalitico() } },
                            ]}

                        />
                    }

                </div>

            </div>
        )
    }

    function getRelatorioApontamentos() {
        atividadeApontamentoService.relatorioApontamentos(getFiltro()).then((data) => {
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `apontamentos.pdf`);
        }).catch((error) => {
            console.log(error);
        });
    }

    function getRelatorioApontamentosAnalitico() {
        atividadeApontamentoService.relatorioApontamentosAnalitico(getFiltro()).then((data) => {
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `apontamentos-analitico.pdf`);
        }).catch((error) => {
            console.log(error);
        });
    }

    function remover(item: BaseModel) {

        confirmDialog({
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            message: 'Deseja realmente excluir este registro?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            accept: () => removerConfirm(item),
        });
    }

    function removerConfirm(item: BaseModel) {

        setExcluindo(true);
        const identificador = item.id;
        if (identificador) {

            atividadeApontamentoService
                .excluir(identificador)
                .then(() => {
                    setExcluindo(false);
                    load();
                    msgSucesso('Apontamentos', 'Registro removido com sucesso!');
                })
                .catch(error => {
                    setExcluindo(false);
                    console.error(error);
                    if (error && error.data && error.data.message) {
                        msgErro('Apontamentos', error.data.message);
                    } else {
                        msgErro('Apontamentos', 'Ocorreu um erro ao tentar remover o registro, tente novamente!');
                    }

                });
        }

    }

    function editar(item: BaseModel) {
        let identificador = item.id ? item.id : item.codigo;
        let url = `/apontamento/editar/${identificador}`;
        navigate(`${url}`);
    }

    function headerTemplate(data: AtividadeApontamento) {

        let totalSemCobrancaFormatada = '';
        let totalComCobrancaFormatada = '';
        if (tipoAgrupamento === 'U') {
            const usuarios = listaGrupoUsuario.filter(g => g.id === data.usuario?.id);
            if (usuarios && usuarios.length > 0) {
                totalSemCobrancaFormatada = usuarios[0].totalSemCobrancaFormatada;
                totalComCobrancaFormatada = usuarios[0].totalComCobrancaFormatada;
            }
        } else if (tipoAgrupamento === 'C') {
            const clientes = listaGrupoUsuario.filter(g => g.id === data.pessoa?.id);
            if (clientes && clientes.length > 0) {
                totalSemCobrancaFormatada = clientes[0].totalSemCobrancaFormatada;
                totalComCobrancaFormatada = clientes[0].totalComCobrancaFormatada;
            }
        } else {
            const atividades = listaGrupoUsuario.filter(g => g.id === data.atividade?.id);
            if (atividades && atividades.length > 0) {
                totalSemCobrancaFormatada = atividades[0].totalSemCobrancaFormatada;
                totalComCobrancaFormatada = atividades[0].totalComCobrancaFormatada;
            }
        }

        let textoAux = '';
        let elementAux = null;
        if (tipoAgrupamento === 'U') {

            for (let index = 0; index < listaHorarioUsuario.length; index++) {
                const element = listaHorarioUsuario[index];
                if (element.idTecnico === data.usuario?.id) {

                    const totalSaldo = (element.saldo ? '' : '-') + element.saldoHorasTrabalhadasFormatada;

                    textoAux = ' | ';
                    textoAux += 'Horas a trabalhar: ' + element.totalHorasTrabalharFormatada;
                    textoAux += ' - Horas trabalhadas: ' + element.totalHorasTrabalhadasFormatada + ' - ';

                    if (element.totalHorasTrabalhar > element.totalHorasTrabalhadas) {
                        elementAux = <span style={{ color: 'red' }}>Saldo: {totalSaldo}</span>;
                    } else if (element.totalHorasTrabalhar < element.totalHorasTrabalhadas) {
                        elementAux = <span style={{ color: 'blue' }}>Saldo: {totalSaldo}</span>;
                    } else {
                        elementAux = <span>Saldo: {totalSaldo}</span>;
                    }

                    break;
                }
            }
        }

        return (
            <>
                <span className="vertical-align-middle ml-2 font-bold line-height-3">{tipoAgrupamento === 'U' ? data.usuario?.nome : (tipoAgrupamento === 'C' ? data.pessoa?.nome : data.atividade?.nome)} - Tempo total com cobrança: {totalComCobrancaFormatada} - Tempo total sem cobrança: {totalSemCobrancaFormatada}{textoAux}{elementAux}</span>
            </>
        );
    };

    return (

        <Base tituloPagina='Apontamentos'>

            <Accordion activeIndex={accordionActiveIndex} onTabChange={(e) => setAccordionActiveIndex(e.index)}>

                <AccordionTab header="Filtros">

                    <div className="row">
                        <label className="col col-sm-12">Agrupamento</label>
                        <div className="col-sm-12">

                            <div className="card flex justify-content-center" style={{ padding: 8, width: 310 }}>
                                <div className="flex flex-wrap gap-3" style={{ display: 'flex' }}>
                                    <div className="flex align-items-center" style={{ display: 'flex' }}>
                                        <RadioButton inputId="tipoAgrupamentoUsuario" name="tipoAgrupamento" value="U" onChange={(e: RadioButtonChangeEvent) => {
                                            load({ ...filters[screen], tipoAgrupamento: e.value })
                                            setTipoAgrupamento(e.value)
                                        }} checked={tipoAgrupamento === 'U'} />
                                        <label htmlFor="tipoAgrupamentoUsuario" className="ml-2" style={{ paddingLeft: 4 }}>Usuário</label>
                                    </div>
                                    <div className="flex align-items-center" style={{ display: 'flex' }}>
                                        <RadioButton inputId="tipoAgrupamentoCliente" name="tipoAgrupamento" value="C" onChange={(e: RadioButtonChangeEvent) => {
                                            load({ ...filters[screen], tipoAgrupamento: e.value })
                                            setTipoAgrupamento(e.value)
                                        }} checked={tipoAgrupamento === 'C'} />
                                        <label htmlFor="tipoAgrupamentoCliente" className="ml-2" style={{ paddingLeft: 4 }}>Cliente</label>
                                    </div>
                                    <div className="flex align-items-center" style={{ display: 'flex' }}>
                                        <RadioButton inputId="tipoAgrupamentoAtividade" name="tipoAgrupamento" value="A" onChange={(e: RadioButtonChangeEvent) => {
                                            load({ ...filters[screen], tipoAgrupamento: e.value })
                                            setTipoAgrupamento(e.value)
                                        }} checked={tipoAgrupamento === 'A'} />
                                        <label htmlFor="tipoAgrupamentoAtividade" className="ml-2" style={{ paddingLeft: 4 }}>Atividade</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <label className="col col-sm-12">Cobrança</label>
                        <div className="col-sm-12">

                            <div className="card flex justify-content-center" style={{ padding: 8, width: 248 }}>
                                <div className="flex flex-wrap gap-3" style={{ display: 'flex' }}>
                                    <div className="flex align-items-center" style={{ display: 'flex' }}>
                                        <RadioButton inputId="cobrancaTodos" name="cobranca" value="T" onChange={(e: RadioButtonChangeEvent) => setCobranca(e.value)} checked={cobranca === 'T'} />
                                        <label htmlFor="cobrancaTodos" className="ml-2" style={{ paddingLeft: 4 }}>Todos</label>
                                    </div>
                                    <div className="flex align-items-center" style={{ display: 'flex' }}>
                                        <RadioButton inputId="cobrancaSim" name="cobranca" value="S" onChange={(e: RadioButtonChangeEvent) => setCobranca(e.value)} checked={cobranca === 'S'} />
                                        <label htmlFor="cobrancaSim" className="ml-2" style={{ paddingLeft: 4 }}>Sim</label>
                                    </div>
                                    <div className="flex align-items-center" style={{ display: 'flex' }}>
                                        <RadioButton inputId="cobrancaNao" name="cobranca" value="N" onChange={(e: RadioButtonChangeEvent) => setCobranca(e.value)} checked={cobranca === 'N'} />
                                        <label htmlFor="cobrancaNao" className="ml-2" style={{ paddingLeft: 4 }}>Não</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <label className="col col-sm-12">Faturado</label>
                        <div className="col-sm-12">

                            <div className="card flex justify-content-center" style={{ padding: 8, width: 248 }}>
                                <div className="flex flex-wrap gap-3" style={{ display: 'flex' }}>
                                    <div className="flex align-items-center" style={{ display: 'flex' }}>
                                        <RadioButton inputId="faturadoTodos" name="faturado" value="T" onChange={(e: RadioButtonChangeEvent) => setFaturado(e.value)} checked={faturado === 'T'} />
                                        <label htmlFor="faturadoTodos" className="ml-2" style={{ paddingLeft: 4 }}>Todos</label>
                                    </div>
                                    <div className="flex align-items-center" style={{ display: 'flex' }}>
                                        <RadioButton inputId="faturadoSim" name="faturado" value="S" onChange={(e: RadioButtonChangeEvent) => setFaturado(e.value)} checked={faturado === 'S'} />
                                        <label htmlFor="faturadoSim" className="ml-2" style={{ paddingLeft: 4 }}>Sim</label>
                                    </div>
                                    <div className="flex align-items-center" style={{ display: 'flex' }}>
                                        <RadioButton inputId="faturadoNao" name="faturado" value="N" onChange={(e: RadioButtonChangeEvent) => setFaturado(e.value)} checked={faturado === 'N'} />
                                        <label htmlFor="faturadoNao" className="ml-2" style={{ paddingLeft: 4 }}>Não</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <label className="col col-sm-12">Data/Hora Início</label>
                        <div className="col-sm-12">

                            <DateTimePicker
                                value={dayjs(dataInicio)}
                                ampm={false}
                                onChange={value => setDataInicio(value?.toDate() || null)}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <label className="col col-sm-12">Data/Hora Fim</label>
                        <div className="col-sm-12">
                            <DateTimePicker
                                value={dayjs(dataFim)}
                                ampm={false}
                                onChange={value => setDataFim(value?.toDate() || null)}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <label className="col col-sm-12">Atividade</label>
                        <div className="col-sm-12">
                            <Dropdown
                                className="col col-sm-12"
                                options={atividades}
                                optionLabel="nome"
                                placeholder="Selecione"
                                value={atividadeSelecionada}
                                style={{ width: 248 }}
                                onChange={(e) => setAtividadeSelecionada(e.value as Atividade)}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <label className="col col-sm-12">Técnico</label>
                        <div className="col-sm-12">
                            <Dropdown
                                className="col col-sm-12"
                                options={usuarios}
                                filter
                                optionLabel="nome"
                                placeholder="Selecione"
                                value={usuarioSelecionado}
                                style={{ width: 248 }}
                                onChange={(e) => setUsuarioSelecionado(e.value as Usuario)}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <label className="col col-sm-12">Cliente</label>
                        <div className="col-sm-12">
                            <Dropdown
                                className="col col-sm-12"
                                options={clientes}
                                optionLabel="nome"
                                filter
                                placeholder="Selecione"
                                value={clienteSelecionado}
                                style={{ width: 248 }}
                                onChange={(e) => setClienteSelecionado(e.value as Pessoa)}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <Checkbox inputId="mostraUsuariosInativos" checked={mostraUsuariosInativos} onChange={(e: any) => {
                                updateFilters(screen, { ...filters[screen], mostraUsuariosInativos: e.checked });
                                setMostraUsuariosInativos(e.checked)
                            }
                            } />
                            <label htmlFor="mostraUsuariosInativos" className="ml-2" style={{ paddingLeft: 4 }}>Mostra usuários inativos</label>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <Checkbox inputId="verDescricao" checked={verDescricao} onChange={(e: any) => {
                                updateFilters(screen, { ...filters[screen], verDescricao: e.checked });
                                setVerDescricao(e.checked)
                            }
                            } />
                            <label htmlFor="verDescricao" className="ml-2" style={{ paddingLeft: 4 }}>Ver descrição</label>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12" style={{ textAlign: 'right' }}>
                            <Button type="button" label="Filtrar" className="ui-button-info" style={{}} onClick={() => {
                                load();
                                setAccordionActiveIndex(-1);
                            }}></Button>
                        </div>
                    </div>



                </AccordionTab>

            </Accordion>

            {visibleEditarRelatorio && <Dialog header="Editar Relatório" visible={visibleEditarRelatorio} style={{ width: '50vw' }} onHide={() => setVisibleEditarRelatorio(false)}>
                {editaRelatoriosSintetico ? <ReportEdit titulo="Relatório de apontamentos de atividades sintético" nomeAcao="RELATORIO_APONTAMENTOS" testarRelatorio={() => { }} /> : null}
                {editaRelatoriosAnalitico ? <ReportEdit titulo="Relatório de apontamentos de atividades analítico" nomeAcao="RELATORIO_APONTAMENTOS_ANALITICO" testarRelatorio={() => { }} /> : null}
            </Dialog>}

            <div className="card" style={{ marginTop: 8 }}>
                <DataTable
                    header={getHeader()}
                    rowGroupMode="subheader"
                    groupRowsBy={tipoAgrupamento === 'U' ? 'usuario.id' : (tipoAgrupamento === 'C' ? 'pessoa.id' : 'atividade.id')}
                    sortMode="single"
                    sortField={tipoAgrupamento === 'U' ? 'usuario.nome' : (tipoAgrupamento === 'C' ? 'pessoa.nome' : 'atividade.nome')}
                    expandableRowGroups
                    expandedRows={expandedRows}
                    onRowToggle={(e: DataTableRowToggleEvent) => setExpandedRows(e.data)}
                    rowGroupHeaderTemplate={headerTemplate}
                    value={rows}
                    dataKey="id"
                    tableStyle={{ minWidth: '75rem' }}
                    loading={filtrando}
                    emptyMessage="Nenhum registro encontrado"
                >
                    {tipoAgrupamento !== 'U' ? <Column field="usuario.nome" header="Técnico" /> : null}
                    {tipoAgrupamento !== 'C' ? <Column field="pessoa.nome" header="Cliente" /> : null}
                    {tipoAgrupamento !== 'A' ? <Column field="atividade.nome" header="Atividade" /> : null}
                    <Column field="atividade.cobranca" header="Cobrança" body={(data) => data.atividade.cobranca ? 'Sim' : 'Não'} />
                    <Column field="dataInicio" header="Inicio" body={(data) => converteData(data.dataInicio)} />
                    <Column field="dataFim" header="Fim" body={(data) => converteData(data.dataFim)} />
                    {verDescricao ? <Column field="descricao" header="Descrição" /> : null}
                    <Column field="faturado" header="Faturado" body={(data) =>
                        <Checkbox checked={data.faturado} onChange={event => {
                            data.faturado = event.checked;
                            setRows([...rows]);
                            atividadeApontamentoService.alterarFaturamento(data.id, event.checked || false);
                        }} />}
                    />
                    <Column key="colOpcoes" style={{ whiteSpace: 'nowrap', width: '7em' }}
                        body={(item) => <div>
                            <Button type="button" icon={<FontAwesomeIcon icon="edit" />} className="ui-button-info" onClick={() => editar(item)}></Button>
                            <Button type="button" icon={<FontAwesomeIcon icon="remove" />} className="ui-button-danger" style={{ marginLeft: 8 }} onClick={() => remover(item)}></Button>
                        </div>}
                    />
                </DataTable>
            </div>
        </Base>
    )
}
